// styles and images
import "../rate-sheets/RateSheets.css";

// components
import DisplayList from "../../components/DisplayList";

// internal hooks
import useGetFetch from "../../hooks/useGetFetch";

// store
import { dbDataStore, triggersStore } from "../../store/Store";
import Loading from "../../components/Loading";

export default function AssetRateSheets() {
  // global state
  const assetRateSheets = dbDataStore((data) => data.assetRateSheets);
  const setAssetRateSheets = dbDataStore((data) => data.setAssetRateSheets);
  const assetRateSheetTrigger = triggersStore(
    (data) => data.assetRateSheetTrigger
  );
  const setAssetRateSheetTrigger = triggersStore(
    (data) => data.setAssetRateSheetTrigger
  );

  const { pending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/asset-rate-sheets`,
    setAssetRateSheets
  );

  return (
    <div className="container-fluid">
      {pending && <Loading />}
      {error && <p className="error">Trouble Retrieving Data</p>}
      {!pending && (
        <DisplayList
          coll={"Asset Rate Sheets"}
          docs={assetRateSheets}
          err={error}
          trigger={assetRateSheetTrigger}
          setTrigger={setAssetRateSheetTrigger}
          url={`${process.env.REACT_APP_BACKEND}/pc/asset-rate-sheets`}
          setState={setAssetRateSheets}
          statusToggle={true}
          setDeleteState={setAssetRateSheets}
        />
      )}
    </div>
  );
}
